import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { superUserVersionList } from "../../redux/actions/superUserAction";
import SuperUserVersionData from "./superUserVersionData";
import LoadingSpinnerTable from "../../components/utilites/loader";
import NumberPagination from "../../components/Pagination/number-pagination";

const SuperUserVersionTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [loading, setLoading] = useState(false);
  const [superUserVersionListData, setSuperUserVersionDataList] = useState([]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(superUserVersionList({ search, page }, onSuccess, onError));
  }, [page, search]);

  const onSuccess = (data) => {
    setLoading(false);
    setSuperUserVersionDataList(data.data.data);
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads " width={"10%"}>
                  Company Employee ID
                </th>
                <th className="table-heads " width={"15%"}>
                  Name
                </th>
                <th className="table-heads " width={"15%"}>
                  Email Address
                </th>
                <th className="table-heads " width={"10%"}>
                  Phone Number
                </th>
                <th className="table-heads " width={"8%"}>
                  Updated By
                </th>
                <th className="table-heads " width={"12%"}>
                  Updated Date
                </th>
                <th className="table-heads " width={"12%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : superUserVersionListData?.superusers?.length > 0 ? (
                <>
                  {superUserVersionListData?.superusers?.map(
                    (eachRow, index) => (
                      <SuperUserVersionData
                        key={eachRow.id}
                        data={eachRow}
                        index={index}
                        currentPage={
                          superUserVersionListData?.pagination?.currentPage
                        }
                      />
                    )
                  )}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading == true ? `loading-event` : ""}>
          {superUserVersionListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={superUserVersionListData?.pagination?.currentPage}
              totalPages={superUserVersionListData?.pagination?.totalPages}
              path={"/super-user/use/version-history"}
              filters={`${queryString}`}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SuperUserVersionTable;
